import { fetchExperienceTimes } from 'actions/ExperienceActions'
import CurrencyContext from 'contexts/currencyContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import type { FetchTimeParams } from 'lib/experiences/experienceUtils'
import { getExperienceTimesKey, isFetchTimesParamsValid } from 'lib/experiences/experienceUtils'
import { useContext, useEffect } from 'react'

function useExperienceAvailableTimes(
  experience: App.ExperienceOffer | undefined,
  params: FetchTimeParams,
): [Array<App.ExperienceAvailabilityTimeSlot>, boolean, any] {
  const { redemptionLocationId, isBuyNowBookLater, isGift, date, pickupPointId } = params

  const dispatch = useAppDispatch()
  const experienceTimes = useAppSelector(state => experience ? state.experience.experienceTimes[experience.id] : undefined)
  const currency = useContext(CurrencyContext)

  const key = getExperienceTimesKey(
    experience?.id ?? '',
    date,
    {
      pickupPointId: experience?.pickupOptional ? undefined : pickupPointId,
      redemptionLocationId,
      isBuyNowBookLater,
      isGift,
      currency,
      ticketModesMap: params.ticketModesMap,
    },
  )

  useEffect(() => {
    if (experience && isFetchTimesParamsValid(experience, params)) {
      dispatch(fetchExperienceTimes(experience.id, {
        currency,
        date,
        isBuyNowBookLater,
        isGift,
        ticketModesMap: params.ticketModesMap,
        pickupPointId: experience?.pickupOptional ? undefined : pickupPointId,
        redemptionLocationId,
      }))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  const record = experienceTimes?.[key]

  return [
    record?.slots ?? EmptyArray,
    !!record?.fetching,
    record?.error,
  ]
}

export default useExperienceAvailableTimes
